/**
 * @generated SignedSource<<87b82c7949fcf729581773da62d1ccb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NOTIFICATION_SCHEDULE = "friday" | "sunday" | "monday" | "off" | "%future added value";
export type PROJECT_NOTIFICATION_SCHEDULE = "mon" | "fri" | "off" | "%future added value";
export type UpdateCompanyInput = {
  name?: string | null;
  street?: string | null;
  zip?: string | null;
  city?: string | null;
  country?: string | null;
  currency?: string | null;
  timezone?: string | null;
  vatId?: string | null;
  logoId?: string | null;
  defaultRateCardId?: string | null;
  defaultHolidayCalendarId?: string | null;
  defaultExpenseCategoryId?: string | null;
  defaultRevenueMarginLow?: number | null;
  defaultRevenueMarginHigh?: number | null;
  disableNotifications?: boolean | null;
  timeRegNotificationSchedule?: string | null;
  projectOverviewNotificationSchedule?: string | null;
  contactPersonId?: string | null;
  contactName?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  companyTarget?: number | null;
  monday?: number | null;
  tuesday?: number | null;
  wednesday?: number | null;
  thursday?: number | null;
  friday?: number | null;
  saturday?: number | null;
  sunday?: number | null;
  useTimeApproval?: boolean | null;
  useInternalTimeApproval?: boolean | null;
  useTimeOffApproval?: boolean | null;
  allUsersModifyTimeOff?: boolean | null;
  harvestDeactivate?: boolean | null;
  timelogDeactivate?: boolean | null;
  economicDeactivate?: boolean | null;
  slackDeactivate?: boolean | null;
  gitlabDeactivate?: boolean | null;
  gitlabServerDeactivate?: boolean | null;
  gitlabDeleteIssues?: boolean | null;
  calendarEnabled?: boolean | null;
  calendarApiEnabled?: boolean | null;
  outlookCalendarApiEnabled?: boolean | null;
  jiraServerUrl?: string | null;
  jiraPrefixType?: string | null;
  jiraServerPrefixType?: string | null;
  tempoOauthClientId?: string | null;
  tempoOauthClientSecret?: string | null;
  salesforceDeactivate?: boolean | null;
  salesforceAutoCreate?: boolean | null;
  xeroUninstall?: boolean | null;
  githubUnauthorizedInstallation?: number | null;
  githubDeactivate?: boolean | null;
  vstsDeactivate?: boolean | null;
  vstsEstimateField?: string | null;
  oktaClientId?: string | null;
  oktaClientSecret?: string | null;
  oktaUrl?: string | null;
  oktaDomainSuffix?: string | null;
  oneloginClientId?: string | null;
  oneloginClientSecret?: string | null;
  oneloginUrl?: string | null;
  unit4Enabled?: boolean | null;
  unit4TwoWay?: boolean | null;
  unit4SyncDateLimit?: string | null;
  AADClientId?: string | null;
  AADClientSecret?: string | null;
  AADTenant?: string | null;
  isUsingSchedulingPlanMode?: boolean | null;
  isUsingProjectAllocation?: boolean | null;
  isUsingMixedAllocation?: boolean | null;
  usingProjectAllocationCreateAllocations?: boolean | null;
  userSeats?: number | null;
  collaboratorSeats?: number | null;
  virtualSeats?: number | null;
  timesheetReminderDay?: string | null;
  timesheetReminderHour?: number | null;
  timesheetReminderEnabled?: boolean | null;
  timesheetReminderIncludeToday?: boolean | null;
  projectDigestNotificationDay?: string | null;
  projectDigestNotificationHour?: number | null;
  projectDigestNotificationEnabled?: boolean | null;
  userCanUnlinkInvoice?: boolean | null;
  skillLevelsEnabled?: boolean | null;
  revenueEnabled?: boolean | null;
  timesheetsEnabled?: boolean | null;
  clientsEnabled?: boolean | null;
  betaOptIn?: boolean | null;
  weekendDisplayPerUser?: boolean | null;
  weekendDisplayShowAlways?: boolean | null;
  invoiceQuantityDecimals?: number | null;
  addFeatureFlagKeysForCypress?: ReadonlyArray<string | null> | null;
  isSSOMandatory?: boolean | null;
  sageIntacctTimeRegsFromForecast?: boolean | null;
  sageIntacctSyncOnlyApproved?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateCompanyMutationModernMutation$variables = {
  input: UpdateCompanyInput;
};
export type updateCompanyMutationModernMutation$data = {
  readonly updateCompany: {
    readonly company: {
      readonly id: string;
      readonly name: string | null;
      readonly currency: string | null;
      readonly timezone: string | null;
      readonly logoId: string | null;
      readonly defaultRateCard: {
        readonly id: string;
      } | null;
      readonly defaultHolidayCalendar: {
        readonly id: string;
      } | null;
      readonly defaultExpenseCategory: {
        readonly id: string;
      } | null;
      readonly defaultRevenueMarginLow: number | null;
      readonly defaultRevenueMarginHigh: number | null;
      readonly vstsEstimateField: string | null;
      readonly disableNotifications: boolean | null;
      readonly slackEnabled: boolean | null;
      readonly githubEnabled: boolean | null;
      readonly githubUnauthorizedInstallation: number | null;
      readonly gitlabEnabled: boolean | null;
      readonly gitlabServerEnabled: boolean | null;
      readonly gitlabDeleteIssues: boolean | null;
      readonly economicEnabled: boolean | null;
      readonly timeRegNotificationSchedule: NOTIFICATION_SCHEDULE | null;
      readonly projectOverviewNotificationSchedule: PROJECT_NOTIFICATION_SCHEDULE | null;
      readonly harvestEnabled: boolean | null;
      readonly calendarEnabled: boolean | null;
      readonly calendarApiEnabled: boolean | null;
      readonly outlookCalendarApiEnabled: boolean | null;
      readonly jiraServerUrl: string | null;
      readonly jiraPrefixType: string | null;
      readonly jiraServerPrefixType: string | null;
      readonly jiraPrefixLoading: boolean | null;
      readonly jiraServerPrefixLoading: boolean | null;
      readonly tempoOauthClientId: string | null;
      readonly tempoOauthClientSecret: string | null;
      readonly xeroEnabled: boolean | null;
      readonly salesforceAutoCreate: boolean | null;
      readonly vstsEnabled: boolean | null;
      readonly oktaClientId: string | null;
      readonly oktaClientSecret: string | null;
      readonly oktaUrl: string | null;
      readonly oktaDomainSuffix: string | null;
      readonly isUsingSchedulingPlanMode: boolean | null;
      readonly userSeats: number | null;
      readonly virtualSeats: number | null;
      readonly monday: number | null;
      readonly tuesday: number | null;
      readonly wednesday: number | null;
      readonly thursday: number | null;
      readonly friday: number | null;
      readonly saturday: number | null;
      readonly sunday: number | null;
      readonly useTimeApproval: boolean | null;
      readonly useInternalTimeApproval: boolean | null;
      readonly useTimeOffApproval: boolean | null;
      readonly allUsersModifyTimeOff: boolean | null;
      readonly lockedPeriodYear: number | null;
      readonly lockedPeriodMonth: number | null;
      readonly lockedPeriodDay: number | null;
      readonly street: string | null;
      readonly zip: string | null;
      readonly city: string | null;
      readonly country: string | null;
      readonly vatId: string | null;
      readonly contactPerson: {
        readonly id: string;
        readonly fullName: string | null;
        readonly email: string | null;
      } | null;
      readonly contactName: string | null;
      readonly contactEmail: string | null;
      readonly contactPhone: string | null;
      readonly oneloginUrl: string | null;
      readonly oneloginClientId: string | null;
      readonly oneloginClientSecret: string | null;
      readonly AADEnabled: boolean | null;
      readonly AADTenant: string | null;
      readonly AADClientId: string | null;
      readonly AADClientSecret: string | null;
      readonly unit4Enabled: boolean | null;
      readonly unit4TwoWay: boolean | null;
      readonly unit4SyncDateLimit: string | null;
      readonly timesheetReminderEnabled: boolean;
      readonly timesheetReminderDay: string;
      readonly timesheetReminderHour: number;
      readonly timesheetReminderIncludeToday: boolean;
      readonly projectDigestNotificationEnabled: boolean;
      readonly projectDigestNotificationDay: string;
      readonly projectDigestNotificationHour: number;
      readonly integrations: {
        readonly userCanUnlinkInvoice: boolean | null;
      } | null;
      readonly skillLevelsEnabled: boolean | null;
      readonly revenueEnabled: boolean | null;
      readonly timesheetsEnabled: boolean | null;
      readonly clientsEnabled: boolean | null;
      readonly betaOptIn: boolean | null;
      readonly weekendDisplayPerUser: boolean | null;
      readonly weekendDisplayShowAlways: boolean | null;
      readonly isUsingProjectAllocation: boolean | null;
      readonly isUsingMixedAllocation: boolean | null;
      readonly invoiceQuantityDecimals: number | null;
      readonly isSSOMandatory: boolean | null;
      readonly sageIntacctTimeRegsFromForecast: boolean | null;
      readonly sageIntacctSyncOnlyApproved: boolean | null;
    } | null;
  } | null;
};
export type updateCompanyMutationModernMutation = {
  variables: updateCompanyMutationModernMutation$variables;
  response: updateCompanyMutationModernMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoId",
  "storageKey": null
},
v7 = [
  (v2/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "defaultRateCard",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "HolidayCalendar",
  "kind": "LinkedField",
  "name": "defaultHolidayCalendar",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseCategory",
  "kind": "LinkedField",
  "name": "defaultExpenseCategory",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRevenueMarginLow",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRevenueMarginHigh",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsEstimateField",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableNotifications",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackEnabled",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "githubEnabled",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "githubUnauthorizedInstallation",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabEnabled",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabServerEnabled",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabDeleteIssues",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "economicEnabled",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeRegNotificationSchedule",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectOverviewNotificationSchedule",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "harvestEnabled",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calendarEnabled",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calendarApiEnabled",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outlookCalendarApiEnabled",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerUrl",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraPrefixType",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerPrefixType",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraPrefixLoading",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerPrefixLoading",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tempoOauthClientId",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tempoOauthClientSecret",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "xeroEnabled",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesforceAutoCreate",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsEnabled",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oktaClientId",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oktaClientSecret",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oktaUrl",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oktaDomainSuffix",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUsingSchedulingPlanMode",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userSeats",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "virtualSeats",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monday",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tuesday",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wednesday",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thursday",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "friday",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saturday",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sunday",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTimeApproval",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useInternalTimeApproval",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTimeOffApproval",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allUsersModifyTimeOff",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedPeriodYear",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedPeriodMonth",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedPeriodDay",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zip",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vatId",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "contactPerson",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactName",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactEmail",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactPhone",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oneloginUrl",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oneloginClientId",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oneloginClientSecret",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "AADEnabled",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "AADTenant",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "AADClientId",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "AADClientSecret",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit4Enabled",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit4TwoWay",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit4SyncDateLimit",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timesheetReminderEnabled",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timesheetReminderDay",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timesheetReminderHour",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timesheetReminderIncludeToday",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectDigestNotificationEnabled",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectDigestNotificationDay",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectDigestNotificationHour",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCanUnlinkInvoice",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skillLevelsEnabled",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueEnabled",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timesheetsEnabled",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientsEnabled",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "betaOptIn",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weekendDisplayPerUser",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weekendDisplayShowAlways",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUsingProjectAllocation",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUsingMixedAllocation",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceQuantityDecimals",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSSOMandatory",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctTimeRegsFromForecast",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctSyncOnlyApproved",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCompanyMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCompanyPayload",
        "kind": "LinkedField",
        "name": "updateCompany",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v70/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/),
              (v81/*: any*/),
              (v82/*: any*/),
              (v83/*: any*/),
              (v84/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyIntegrationsType",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  (v85/*: any*/)
                ],
                "storageKey": null
              },
              (v86/*: any*/),
              (v87/*: any*/),
              (v88/*: any*/),
              (v89/*: any*/),
              (v90/*: any*/),
              (v91/*: any*/),
              (v92/*: any*/),
              (v93/*: any*/),
              (v94/*: any*/),
              (v95/*: any*/),
              (v96/*: any*/),
              (v97/*: any*/),
              (v98/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCompanyMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCompanyPayload",
        "kind": "LinkedField",
        "name": "updateCompany",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v70/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/),
              (v81/*: any*/),
              (v82/*: any*/),
              (v83/*: any*/),
              (v84/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyIntegrationsType",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  (v85/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v86/*: any*/),
              (v87/*: any*/),
              (v88/*: any*/),
              (v89/*: any*/),
              (v90/*: any*/),
              (v91/*: any*/),
              (v92/*: any*/),
              (v93/*: any*/),
              (v94/*: any*/),
              (v95/*: any*/),
              (v96/*: any*/),
              (v97/*: any*/),
              (v98/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d0d1cdaecfb3f155dae63fafcc38720b",
    "id": null,
    "metadata": {},
    "name": "updateCompanyMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateCompanyMutationModernMutation(\n  $input: UpdateCompanyInput!\n) {\n  updateCompany(input: $input) {\n    company {\n      id\n      name\n      currency\n      timezone\n      logoId\n      defaultRateCard {\n        id\n      }\n      defaultHolidayCalendar {\n        id\n      }\n      defaultExpenseCategory {\n        id\n      }\n      defaultRevenueMarginLow\n      defaultRevenueMarginHigh\n      vstsEstimateField\n      disableNotifications\n      slackEnabled\n      githubEnabled\n      githubUnauthorizedInstallation\n      gitlabEnabled\n      gitlabServerEnabled\n      gitlabDeleteIssues\n      economicEnabled\n      timeRegNotificationSchedule\n      projectOverviewNotificationSchedule\n      harvestEnabled\n      calendarEnabled\n      calendarApiEnabled\n      outlookCalendarApiEnabled\n      jiraServerUrl\n      jiraPrefixType\n      jiraServerPrefixType\n      jiraPrefixLoading\n      jiraServerPrefixLoading\n      tempoOauthClientId\n      tempoOauthClientSecret\n      xeroEnabled\n      salesforceAutoCreate\n      vstsEnabled\n      oktaClientId\n      oktaClientSecret\n      oktaUrl\n      oktaDomainSuffix\n      isUsingSchedulingPlanMode\n      userSeats\n      virtualSeats\n      monday\n      tuesday\n      wednesday\n      thursday\n      friday\n      saturday\n      sunday\n      useTimeApproval\n      useInternalTimeApproval\n      useTimeOffApproval\n      allUsersModifyTimeOff\n      lockedPeriodYear\n      lockedPeriodMonth\n      lockedPeriodDay\n      street\n      zip\n      city\n      country\n      vatId\n      contactPerson {\n        id\n        fullName\n        email\n      }\n      contactName\n      contactEmail\n      contactPhone\n      oneloginUrl\n      oneloginClientId\n      oneloginClientSecret\n      AADEnabled\n      AADTenant\n      AADClientId\n      AADClientSecret\n      unit4Enabled\n      unit4TwoWay\n      unit4SyncDateLimit\n      timesheetReminderEnabled\n      timesheetReminderDay\n      timesheetReminderHour\n      timesheetReminderIncludeToday\n      projectDigestNotificationEnabled\n      projectDigestNotificationDay\n      projectDigestNotificationHour\n      integrations {\n        userCanUnlinkInvoice\n        id\n      }\n      skillLevelsEnabled\n      revenueEnabled\n      timesheetsEnabled\n      clientsEnabled\n      betaOptIn\n      weekendDisplayPerUser\n      weekendDisplayShowAlways\n      isUsingProjectAllocation\n      isUsingMixedAllocation\n      invoiceQuantityDecimals\n      isSSOMandatory\n      sageIntacctTimeRegsFromForecast\n      sageIntacctSyncOnlyApproved\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cb4628d0005b320bb3ec9fc174061ee9";

export default node;
